<template>
    <div>
        <sav-template :display-left-img="false">
            <h2 class="text-xl font-bold">{{ $tt('Demande de compléments') }}</h2>
            <div>Pour finaliser le traitement de votre dossier, nous avons besoin d’informations complémentaires</div>
            
            <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-4">
                    <div class="bg-slate-100 p-2 rounded shadow border">
                        <div class="font-bold"><i class="fas fa-folder mr-0.5"></i> Votre dossier</div>
                        <div class="mt-1 border-t pt-1">
                            <div class="text-sm font-light text-slate-600">Appareil</div>
                            <div class="text-sm">Test - DevFromSavlog</div>
                        </div>
                        <div class="mt-1 border-t pt-1">
                            <div class="text-sm font-light text-slate-600">Numéro de série</div>
                            <div class="text-sm">2931809389138298130932819</div>
                        </div>
                        <div class="mt-1 border-t pt-1">
                            <div class="text-sm font-light text-slate-600">IMEI</div>
                            <div class="text-sm">123456</div>
                        </div>
                        <div class="mt-1 border-t pt-1">
                            <div class="text-sm font-light text-slate-600">Date d'achat</div>
                            <div class="text-sm">09/09/2024</div>
                        </div>
                    </div>
                </div>
                <div class="col-span-8">
                    <div class="border p-4 rounded mb-2">
                        <div class="flex items-center gap-2">
                            <div class="w-[35px] aspect-square rounded-full" :style="'background-size: cover; background-position: center center; background-image: url(' + avatar + ')'"></div>
                            <div>
                                <div class="font-bold">{{ $companyTool.confFile().name }}</div>
                                <div class="text-xs font-light">Envoyé le 02/04/2025</div>
                            </div>
                        </div>
                        <div class="mt-2">
                            Bonjour, pour finaliser le traitement de votre dossier, nous avons besoin d’informations complémentaires. Merci de nous les transmettre dans les plus brefs délais.
                        </div>
                    </div>
                    
                    <div class="border p-4 rounded mb-2">
                        <div class="flex items-center gap-2">
                            <div class="w-[35px] aspect-square rounded-full" style="background-size: cover; background-position: center center; background-image: url(https://disticloudfiles.net/upload/files/user.jpg)"></div>
                            <div>
                                <div class="font-bold">Merci de renseigner les champs suivants :</div>
                                <!-- <div class="text-xs font-light">Envoyé le 02/04/2025</div> -->
                            </div>
                        </div>
                        <div class="mt-2">
                            
                            <!-- <div>Bonjour, Voici mon fichier ci-joint.</div> -->
                            <!-- <div class="mt-1">
                                <span class="border px-2 py-1 font-bold text-xs hover:bg-slate-100 duration-200 cursor-pointer">
                                    <i class="fas fa-link mr-1"></i> Document
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </sav-template>
    </div>
</template>

<script>
export default {
    computed: {
        avatar() {
            return this.$companyTool.confFile().style.logo || 'https://disticloudfiles.net/img/savinfo/default/avatar-chat-bot.png'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/companies/default/views/complements/Complements.vue